import moment from '../../../../services/moment_instance';

export const getEtapaForConference = (creationDate) => {
  const createdAt = moment.tz(creationDate, 'America/Bogota').startOf('day');
  const preVentaStart = moment.tz('2025-06-13', 'YYYY-MM-DD', 'America/Bogota').startOf('day');
  const preVentaEnd = moment.tz('2026-02-27', 'YYYY-MM-DD', 'America/Bogota').endOf('day');
  const legadoStart = moment.tz('2026-02-28', 'YYYY-MM-DD', 'America/Bogota').startOf('day');
  const legadoEnd = moment.tz('2026-03-29', 'YYYY-MM-DD', 'America/Bogota').endOf('day');
  const familiaStart = moment.tz('2026-03-30', 'YYYY-MM-DD', 'America/Bogota').startOf('day');
  const familiaEnd = moment.tz('2026-05-03', 'YYYY-MM-DD', 'America/Bogota').endOf('day');
  const generalStart = moment.tz('2026-05-04', 'YYYY-MM-DD', 'America/Bogota').startOf('day');

  if (createdAt.isBetween(preVentaStart, preVentaEnd, undefined, '[]')) return 'pre_venta';
  if (createdAt.isBetween(legadoStart, legadoEnd, undefined, '[]')) return 'legado';
  if (createdAt.isBetween(familiaStart, familiaEnd, undefined, '[]')) return 'familia';
  if (createdAt.isSameOrAfter(generalStart)) return 'general';
  return '';
};

const ETAPA_LABELS = {
  pre_venta: 'PRE-VENTA',
  legado: 'LEGADO',
  familia: 'FAMILIA',
  general: 'GENERAL',
};

export const confPerfectaComunion = (eventDate) => {
  const etapaKey = getEtapaForConference(eventDate);
  const name = etapaKey ? ETAPA_LABELS[etapaKey] : null;
  return (
    <div style={{ margin: '10px 0' }}>
      Etapa en la que se inscribió: <strong>{name}</strong>
    </div>
  );
};
